import { useOkapiKy } from '@folio/stripes/core';
import { useQuery } from 'react-query';
import { fetchProposalDetail } from '../api/proposalService';
/**
 * Hook for fetching a single proposal detail.
 * Skips the request when id is undefined (no proposal selected).
 */
var useProposalDetail = function (id) {
    var ky = useOkapiKy();
    var _a = useQuery(['proposal', id], function () { return fetchProposalDetail(ky, id); }, {
        enabled: !!id,
    }), data = _a.data, isLoading = _a.isLoading, isError = _a.isError, error = _a.error, refetch = _a.refetch;
    return {
        proposal: data,
        isLoading: isLoading,
        isError: isError,
        error: error,
        refetch: refetch,
    };
};
export default useProposalDetail;
